export const REQUEST_CHECK_LOGIN = 'REQUEST_CHECK_LOGIN'
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT'